import React, { useEffect, useState } from 'react';
import { Form, FormCheck, Row, Col, Card, Modal, Spinner, Button } from "react-bootstrap";
import Select from "react-select";
import { useParams, useNavigate } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import MyApiClient from '../../../../../api-client/MyApiClient';
import { segnalaMancanti } from '../../../../components/Util/campiMancanti';
import { usePageTitle, useStatoInSolaLettura } from '../../../../layouts/PageHeaderExtra';
import { conMotivo } from "../../../../components/Util/erroreServer";
import "react-widgets/styles.css";
import { format } from 'date-fns';

const options = [
  { value: "PLAYERS", label: "Players" },
  { value: "GURUS", label: "Maestri" },
  { value: "JUNIORS", label: "Junior" },
  { value: "CLUB_MEMBERS", label: "Soci" },
  { value: "CLUB_COACHES", label: "Staff Tecnico" },
  { value: "CLUB_DIRECTORS", label: "CDA" },
];

export const ComunicazioneGenericheEdit = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const [isEditable, setIsEditable] = useState(false);
  
  const [isChecked, setIsChecked] = useState(false);
  const [formData, setFormData] = useState({
    type: 'GENERIC',
    subject: '',
    messageHtml: '',
    scheduled: false,
    scheduledAt_date: '',
    scheduledAt_time: '',
    scheduledAt: 0,
    recipientGroups: []
  });

  const [modalShowed, setModalShowed] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalText, setModalText] = useState('');

  const [confirmShowed, setConfirmShowed] = useState(false);
	const [onContinue, setOnContinue] = useState(null);

  const [loadingShowed, setLoadingShowed] = useState(false);

  // Conferma dell'eliminazione (prima nel menu a fine riga della lista)
  const [confirmDeleteShowed, setConfirmDeleteShowed] = useState(false);
  // Titolo della pagina: si imposta quando i dati sono caricati
  const [titoloPagina, setTitoloPagina] = useState('');
  usePageTitle(titoloPagina);
  // Stato in sola lettura accanto al titolo, come nella lista: Programmata finché non parte, poi Inviata
  useStatoInSolaLettura(titoloPagina ? (isEditable ? 'Programmata' : 'Inviata') : '', isEditable ? 'bozza' : 'attivo');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
        ...prevState,
        [name]: value
    }));
  };

  const handleCheckboxChange = () => {
    setFormData(prevState => ({
      ...prevState,
      ['scheduled']: !isChecked
    }));
    setIsChecked(!isChecked);
  };

  const handleSelectChange = (selectedOptions) => {
    const selectedGroups = selectedOptions.map(option => option.value);
    setFormData(prevState => ({
        ...prevState,
        recipientGroups: selectedGroups
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
          const tokenDetails = JSON.parse(tokenDetailsString);
          let token = tokenDetails.idToken;
          const apiClient = new MyApiClient();

          setLoadingShowed(true);
          const [documentsData] = await Promise.all([
            apiClient.getCommunications(token)
          ]);
          setLoadingShowed(false);

          let formDataRead = null;
          if(documentsData) {
            documentsData.forEach(element => {
              if(element.id==id) {
                formDataRead = [];
                formDataRead.subject = element.subject;
                setTitoloPagina(element.subject || '');
                formDataRead.messageHtml = element.messageHtml;
                formDataRead.recipientGroups = element.recipientGroups;
                formDataRead.scheduled = true;
                setIsChecked(true);

                let data_scheduled = format(element.scheduledAt, 'yyyy-MM-dd HH:mm');
                let data_scheduled_split = data_scheduled.split(' ');
                formDataRead.scheduledAt_date = data_scheduled_split[0];
                formDataRead.scheduledAt_time = data_scheduled_split[1];

                if(element.scheduledAt>Date.now()) {
                  setIsEditable(true);
                }
              }
            }); 
          }

          if(formDataRead) {
            setFormData(formDataRead);
          } else {
            setModalTitle("Errore durante l'operazione");
            setModalText('Errore durante la lettura.');
            setModalShowed(true);
            return;
          }
        }
      } catch (error) {
          console.error("Error fetching data:", error);
      }
    };

    fetchData();

  }, []);

  const handleSaveClick = (e) => {
    e.preventDefault();

    // Dati mancanti (regola SUI): campo evidenziato con la frase sotto, scroll e cursore sul primo
    const mancanti = [];
    if (!formData.subject.trim()) mancanti.push({ campo: 'com-titolo', messaggio: 'Manca il titolo della comunicazione' });
    if (!formData.recipientGroups || formData.recipientGroups.length === 0) mancanti.push({ campo: 'com-destinatari', messaggio: 'Manca almeno una tipologia di destinatario' });
    if (isChecked && !formData.scheduledAt_date) mancanti.push({ campo: 'com-data', messaggio: "Manca la data dell'invio" });
    if (isChecked && !formData.scheduledAt_time) mancanti.push({ campo: 'com-ora', messaggio: "Manca l'ora dell'invio" });
    if (!formData.messageHtml) mancanti.push({ campo: 'com-contenuto', messaggio: 'Manca il contenuto della comunicazione' });
    if (segnalaMancanti(mancanti) > 0) return;

    setOnContinue(() => () => continueSaveDoc());
		setConfirmShowed(true);
  };

  const continueSaveDoc = (row) => {

    setConfirmShowed(false);

    const saveData = async () => {
      try {
          const tokenDetailsString = sessionStorage.getItem('userDetails');
          if (tokenDetailsString) {
              const tokenDetails = JSON.parse(tokenDetailsString);
              const token = tokenDetails.idToken;
              const apiClient = new MyApiClient();

              const dateTimeStr = `${formData.scheduledAt_date}T${formData.scheduledAt_time}:00Z`;
              const date = new Date(dateTimeStr);
              const timestamp = date.getTime();
              formData.scheduledAt = timestamp;

              let data_insert = {
                'type': formData.type,
                'subject': formData.subject,
                'messageHtml': formData.messageHtml,
                'recipientGroups': formData.recipientGroups
              }

              if(formData.scheduledAt) {
                data_insert['scheduledAt'] = formData.scheduledAt;
              }

              setLoadingShowed(true);
              const saveResult = await apiClient.editCommunication(token, id, data_insert);
              setLoadingShowed(false);

              if (saveResult && saveResult.error) {
                setModalTitle("Errore durante l'operazione");
                setModalText("Si è verificato un errore durante il salvataggio (" + saveResult.error + ")");
                setModalShowed(true);
              } else {
                navigate('/struttura/comunicazioni/generiche');
              }
          }
      } catch (error) {
          console.error("Error fetching data:", error);
      }
    };

    saveData();
  };

  // Eliminazione: spostata qui dalla lista (comunicazioni/generiche/index.js)
  const continueDeleteDoc = () => {

    setConfirmDeleteShowed(false);

    const deleteData = async () => {
      try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
          const tokenDetails = JSON.parse(tokenDetailsString);
          const token = tokenDetails.idToken;
          const apiClient = new MyApiClient();

          setLoadingShowed(true);
          const saveResult = await apiClient.deleteCommunications(token, id);
          setLoadingShowed(false);

          if(!saveResult) {
            setModalTitle("Errore durante l'operazione");
            setModalText(conMotivo("Si è verificato un errore durante l'eliminazione"));
            setModalShowed(true);
          } else {
            navigate('/struttura/comunicazioni/generiche');
          }
        }
      } catch (error) {
        setLoadingShowed(false);
        console.error("Error fetching data:", error);
      }
    };

    deleteData();
  };

  return (
    <>
      <Modal className="fade" show={confirmDeleteShowed} centered>
        <Modal.Header>
          <Modal.Title>Eliminare la comunicazione?</Modal.Title>
          <Button onClick={() => setConfirmDeleteShowed(false)} variant="" className="btn-close">
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Row><Col className="col-xl-64">Vuoi eliminare la comunicazione <strong>{formData.subject}</strong>? L'operazione non è reversibile.</Col></Row>
        </Modal.Body>
        <Modal.Footer className="justify-content-center sid-footer-conferma">
          <Button className="btn btn-light btn-add" onClick={() => setConfirmDeleteShowed(false)}>
            Annulla
          </Button>
          <Button className="btn btn-danger btn-add" onClick={continueDeleteDoc}>
            Elimina
          </Button>
        </Modal.Footer>
      </Modal>
      <style>
          {`
              [dir="ltr"] .ck.ck-dropdown .ck-dropdown__arrow {
                z-index: 0;
              }

              .ck.ck-editor__editable_inline > :first-child {
                height: 90%;
              }

              .ck-content {
                min-height: 200px;
                margin-bottom: 50px;
              }
          `}
      </style>

      <Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

      <Modal className="fade" show={confirmShowed} centered>
        <Modal.Header closeButton>
          <Modal.Title>{formData.scheduled ? "Programmare l'invio?" : 'Inviare la comunicazione?'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className="col-xl-64">
              {formData.scheduled && <b>La comunicazione sarà inviata all'orario schedulato.</b>}
              {!formData.scheduled && <b>La comunicazione sarà inviata immediatamente.</b>}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="justify-content-center sid-footer-conferma">
          <Button className="btn btn-light btn-add" onClick={() => setConfirmShowed(false)}>
            Annulla
          </Button>
          <Button className="btn btn-primary btn-add" onClick={() => { setConfirmShowed(false); if (onContinue) onContinue(); }}>
            {formData.scheduled ? 'Programma' : 'Invia'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal className="fade" show={modalShowed} centered>
        <Modal.Header>
          <Modal.Title>{modalTitle}</Modal.Title>
          <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Row><Col className="col-xl-64">{modalText}</Col></Row>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
              Chiudi
          </Button>
        </Modal.Footer>
      </Modal>
      
      <Form noValidate onSubmit={(e) => e.preventDefault()}>
        <Card>
          <Card.Header><h5>Crea una nuova comunicazione</h5></Card.Header>
          <Card.Body>
            <Row>
              <Col>
                <Form.Label htmlFor="com-titolo">Titolo *</Form.Label>
                <Form.Control id="com-titolo" type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="Inserisci il titolo della comunicazione" />
              </Col></Row>
            <Row>
              <Col>
                <Form.Label htmlFor="com-destinatari" className="mt-4">Tipologia destinatario *</Form.Label>
                <Select
                  inputId="com-destinatari"
                  value={options.filter(option => formData.recipientGroups ? formData.recipientGroups.includes(option.value) : '')}
                  isMulti
                  options={options}
                  onChange={handleSelectChange}
                  placeholder="Seleziona la tipologia di destinatario a cui spedire"
                  style={{
                    lineHeight: "40px",
                    color: "#fd7e14",
                    paddingLeft: " 15px",
                  }
                  }
                />
              </Col>
            </Row>
            <Row className="mt-4">
              <Form.Group controlId="prodottoConListaAttesa">
                <FormCheck
                  className="d-flex"
                  type="checkbox"
                  label="Programma l'invio (se non selezionato la comunicazione verrà inviata immediatamente)"
                  value=""
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
              </Form.Group>
            </Row>
            {isChecked &&
              <Row>
                <Col>
                  <Form.Label htmlFor="com-data">Seleziona data *</Form.Label>
                  <Form.Control id="com-data" type="date" name="scheduledAt_date" value={formData.scheduledAt_date} onChange={handleChange} ></Form.Control>
                </Col>
                <Col>
                  <Form.Label htmlFor="com-ora">Seleziona ora *</Form.Label>
                  <Form.Control id="com-ora" type="time" name="scheduledAt_time" value={formData.scheduledAt_time} onChange={handleChange} ></Form.Control>
                </Col>
              </Row>
            }
            <Row>
              <Form.Label htmlFor="com-contenuto" className="mt-4">Contenuto *</Form.Label>
              <div id="com-contenuto" tabIndex={-1} className="custom-ekeditor">
                <CKEditor
                  editor={ClassicEditor}
                  data={formData.messageHtml}
                  // data="<p>Hello from CKEditor 5!</p>"
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    // console.log('Editor is ready to use!', editor);
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    // console.log({ event, editor, data });
                    formData.messageHtml = data;
                  }}
                  onBlur={(event, editor) => {
                    // console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    // console.log('Focus.', editor);
                  }}
                />
              </div>
            </Row>
          </Card.Body>
        </Card>
        <div className={`d-flex ${isEditable ? 'justify-content-between' : 'justify-content-end'} mt-4`}>
          {/* Si elimina solo finché non è stata inviata */}
          {isEditable && <button type="button" className="btn btn-danger light" onClick={() => setConfirmDeleteShowed(true)}>Elimina</button>}
          <div className="d-flex gap-4">
          <button type="button" className="btn btn-dark light" onClick={() => navigate('/struttura/comunicazioni/generiche')}>Annulla</button>
          { isEditable && <button type="button" className="btn btn-primary" onClick={handleSaveClick}>Salva</button> }
          </div>
        </div>
      </Form>
    </>
  )

}
export default ComunicazioneGenericheEdit;